<template>
  <div class="con">
    <div v-if="!isLoading">
      <div class="title">
        <h2>프로그램 선택하기</h2>
        <p>신청할 프로그램을 선택해 주시기 바랍니다.</p>
      </div>
      <div class="apply-main-program">
        <ul>
          <li
            v-for="(item, index) of program_types"
            :key="index"
            class="pointer"
            @click="apply(item.program_type, item.programIdx)"
          >
            <p class="program-title">{{ item.program_name }}</p>
            <span>신청하기</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else style="height: 560px">
      <loading></loading>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/loading.vue";
export default {
  components: {
    Loading: Loading,
  },
  data: () => ({
    G: false,
    L: false,
    U: false,
    S: false,
    E: false,

    program_types: [],
    pOrder: [],

    isLoading: false,
  }),

  mounted() {
    this.isLoading = true;
    this.loadSugang(sessionStorage.getItem("pageIdx"));
  },

  methods: {
    // 선택한 수강페이지 등록 진행 => 약관동의 페이지 이동
    apply(type, idx) {
      sessionStorage.setItem("program_type", type);
      sessionStorage.setItem("programIdx", idx);
      if (sessionStorage.getItem("program_dup_YN") === "N") {
        this.chooseProgram(idx);
      } else {
        this.$router.push(`/user/reg/${this.pOrder[0]}`);
      }
    },

    // 수강신청 불러오기
    async loadSugang(pageIdx) {
      await this.axios
        .get(this.axios.root + this.axios.port + `/sugang/page/${pageIdx}`)
        .then((res) => {
          if (res.data.err === 0) {
            if ("Y" == res.data.info.isUser) {
              sessionStorage.setItem("isRegUser", "Y");
            } else {
              sessionStorage.setItem("isRegUser", "N");
            }

            var pOrder = [];
            for (var i = 1; i <= 8; i++) {
              for (var item of res.data.menu) {
                if (item.order === i.toString()) {
                  if (item.status === "Y") {
                    if (item.name === "agree") {
                      pOrder.push("terms");
                    } else if (item.name === "guide") {
                      pOrder.push("info");
                    } else if (item.name === "choose") {
                      pOrder.push("select");
                    } else if (item.name === "info") {
                      pOrder.push("input");
                    } else if (item.name === "pay") {
                      pOrder.push("payment");
                    } else if (item.name === "complete") {
                      pOrder.push("complete");
                    } else if (item.name === "popup") {
                      sessionStorage.setItem("selectPopup", true);
                    }
                  }
                }
              }
            }

            this.progressOrder = pOrder;
            this.pOrder = pOrder;

            sessionStorage.setItem("pOrder", JSON.stringify(pOrder));
            sessionStorage.setItem("category", res.data.pageInfo.category);

            if (sessionStorage.getItem("program_types")) {
              this.program_types = JSON.parse(
                sessionStorage.getItem("program_types")
              );
              if (sessionStorage.getItem("pOrder")) {
                this.pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
              }

              // this.chooseProgram(this.program_types[1].programIdx)

              if (this.program_types.length === 0) {
                this.isLoading = false;
                this.$router.push(`/user/reg/${this.pOrder[0]}`);
                return false;
              } else if (this.program_types.length < 2) {
                sessionStorage.setItem(
                  "programIdx",
                  this.program_types[0].programIdx
                );
                var programIdx = this.program_types[0].programIdx;
                var params = {
                  programIdx: this.program_types[0].programIdx,
                };

                this.axios
                  .get(
                    this.axios.root +
                      this.axios.port +
                      `/user/choose-program/${programIdx}`,
                    {
                      params: params,
                    }
                  )
                  .then((res) => {
                    // console.log(res);
                    // this.$router.push(`/user/reg/${this.pOrder[0]}`);
                    this.isLoading = false;
                    if (res.data.err === 0) {
                      this.$router.push(`/user/reg/${this.pOrder[0]}`);
                    } else if (res.data.err === 100) {
                      alert(
                        "신청가능 대상자가 아닙니다.\n관련하여 궁금하신 점은 1:1 문의 부탁드립니다."
                      );
                      this.$router.push("/user/login");
                      return false;
                    } else {
                      alert(res.data.result);
                      this.$router.push("/user/login");
                      return false;
                    }
                  })
                  .catch((err) => {
                    this.isLoading = false;
                    alert(err);
                    // console.log(err)
                  });
                // this.$router.push(`/user/reg/${this.pOrder[0]}`);
              } else {
                this.isLoading = false;
              }
            } else {
              this.isLoading = false;
              this.$router.push(`/user/reg/${this.pOrder[0]}`);
            }
          }
        })
        .catch((err) => {
          // console.log('err', err)
          alert(err);
          this.isLoading = false;
        });
    },

    // 프로그램 선택 api
    chooseProgram(programIdx) {
      var params = {
        programIdx: programIdx,
      };

      this.axios
        .get(
          this.axios.root +
            this.axios.port +
            `/user/choose-program/${programIdx}`,
          {
            params: params,
          }
        )
        .then((res) => {
          // console.log(res);
          // this.$router.push(`/user/reg/${this.pOrder[0]}`);
          if (res.data.err === 0) {
            this.$router.push(`/user/reg/${this.pOrder[0]}`);
          } else if (res.data.err === 100) {
            alert(res.data.result);
            this.$router.push("/user/login");
            return false;
          } else {
            this.$router.push("/user/login");
            alert(res.data.result);
            return false;
          }
        });
    },
  },
};
</script>
